export default function (str) { return str.trim(); };

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/Ractive/prototype/shared/trim.js.map
